module.exports = __webpack_public_path__ + "img/big_1_53.262e732d.png";